import { put, call, takeLatest } from 'redux-saga/effects';
import { actions } from './Reducer';
import {
  setArtisanProductsIsLoadingAction,
  getArtisanProductsSuccessAction,
  getArtisanProductSuccessAction,
  createArtisanProductSuccessAction,
  setArtisanProductsCountAction,
  updateArtisanProductSuccessAction,
  getArtisanProductsPicturesSuccess,
  getArtisanProductsSuccessChangeAction
} from './Actions';
import {
  newSuccessNotificationAction,
  errorNotificationFromError
} from '../notifications/Actions';
import * as api from './Api';
import { push } from 'connected-react-router';
import { setArtisanCategoriesCountAction } from '../artisanCategories/Actions';
import { setArtisansIsLoadingAction } from '../artisans/Actions';

function* getArtisanProduct({ payload }) {
  const productId = payload;

  try {
    yield put(setArtisanProductsIsLoadingAction(true));
    const response = yield call(api.getArtisanProduct, productId);
    const { data } = response;
    const product = data;
    yield put(getArtisanProductSuccessAction(product));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setArtisanProductsIsLoadingAction(false));
  }
}

function* updateArtisanProduct({ payload }) {
  const { formData, id } = payload;

  try {
    yield put(setArtisanProductsIsLoadingAction(true));
    const response = yield call(api.updateArtisanProduct, id, formData);
    const { data } = response;
    const product = data;
    yield put(newSuccessNotificationAction(`Product Updated !`));
    yield put(push('/artisan-products'));
    yield put(updateArtisanProductSuccessAction(product));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setArtisanProductsIsLoadingAction(false));
  }
}

function* createArtisanProduct({ payload }) {
  try {
    yield put(setArtisanProductsIsLoadingAction(true));
    const response = yield call(api.createArtisanProduct, { ...payload });
    const { data } = response;
    const product = data;
    yield put(newSuccessNotificationAction(`Product Created !`));
    yield put(createArtisanProductSuccessAction(product));
    yield put(push('/artisan-products'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setArtisanProductsIsLoadingAction(false));
  }
}

function* getArtisanProducts({ payload }) {
  const defData = {
    offset: 0,
    size: 10,
    searchTerm: '',
    filterBy: [{}],
    filterCountry: '',
    sort: 'name',
    dir: 'asc'
  };

  const body = { ...defData, ...payload };

  try {
    yield put(setArtisanProductsIsLoadingAction(true));
    const response = yield call(api.getArtisanProducts, body);
    const { content, count } = response.data;
    yield put(setArtisanProductsCountAction(count));
    if (body.filterArtisan) {
      yield put(getArtisanProductsSuccessChangeAction(content));
    } else {
      yield put(getArtisanProductsSuccessAction(content));
    }
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setArtisanProductsIsLoadingAction(false));
  }
}

function* getArtisanProductsPictures({ payload }) {
  try {
    yield put(setArtisanProductsIsLoadingAction(true));
    const response = yield call(api.getArtisanProductsPictures);
    const { data } = response;
    yield put(getArtisanProductsPicturesSuccess(data));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setArtisanProductsIsLoadingAction(false));
  }
}

function* addEditorReview({ payload }) {
  const { id, formData } = payload;
  try {
    yield put(setArtisanProductsIsLoadingAction(true));
    const response = yield call(api.addEditorsReview, id, formData);
    const { data } = response;
    yield put(updateArtisanProductSuccessAction(data));
    yield put(newSuccessNotificationAction('Thanks for Your Review'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setArtisansIsLoadingAction(false));
  }
}

export default function*() {
  yield takeLatest(actions.UPDATE_ARTISAN_PRODUCT, updateArtisanProduct);
  yield takeLatest(actions.GET_ARTISAN_PRODUCT, getArtisanProduct);
  yield takeLatest(actions.GET_ARTISAN_PRODUCTS, getArtisanProducts);
  yield takeLatest(actions.CREATE_ARTISAN_PRODUCT, createArtisanProduct);
  yield takeLatest(actions.ADD_EDITOR_REVIEW_ARTISAN_PRODUCT, addEditorReview);
  yield takeLatest(
    actions.GET_ARTISAN_PRODUCTS_PICTURES,
    getArtisanProductsPictures
  );
}
